<template>
<div style="width:100%">
  <van-collapse v-model="activeNames">
    <van-collapse-item title="发票信息" name="1">
      <van-field v-model="inputForm.invoiceDetail.invoice_type_org" label="发票名称" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.invoice_type" label="发票类型" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.invoice_code" label="发票代码" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.invoice_num" label="发票号码" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.check_code" label="校验码" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.invoice_date" label="开票日期" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.purchaser_name" label="购方名称" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.purchaser_register_num" label="购方纳税人识别号" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.purchaser_address" label="购方地址及电话" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.purchaser_bank" label="购方开户行及账号" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.seller_name" label="销售方名称" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.seller_register_num" label="销售方纳税人识别号" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.seller_address" label="销售方地址及电话" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.seller_bank" label="销售方开户行及账号" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.total_amount" label="合计金额（元）" :formatter="formatter" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.total_tax" label="合计税额（元）" :formatter="formatter" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.amount_in_words" label="价税合计(大写)" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.amount_in_figuers" label="价税合计(小写)" :formatter="formatter" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.payee" label="收款人" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.checker" label="复核人" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.note_drawer" label="开票人" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <van-field v-model="inputForm.invoiceDetail.remarks" label="备注" label-width="100px" readonly input-align="left"
                 :border="false" autosize rows="1" type="textarea"/>
      <div style="padding-left: 16px; margin-bottom: 10px; margin-top: 10px">
        <p style="display: block; color: #4caedc" @click="viewInvoiceDetail()">查看发票明细</p>
      </div>

      <div style="padding-left: 16px;" v-show="inputForm.attachList&&inputForm.attachList.length > 0">
        <p>附件</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index"
           @click="$viewAttach(file)">{{ file.name }}</p>
      </div>
    </van-collapse-item>
<!--    <van-collapse-item title="业务信息" name="3">-->

<!--      <div style="padding-left: 16px;" v-show="inputForm.attachList&&inputForm.attachList.length > 0">-->
<!--        <p>附件</p>-->
<!--        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index"-->
<!--           @click="$viewAttach(file)">{{ file.name }}</p>-->
<!--      </div>-->
<!--    </van-collapse-item>-->
  </van-collapse>
</div>
</template>

<script>
export default {
  name: "vatInvoiceFlowForm",
  data(){
    return {
      inputForm:{
        invoiceDetail:{}
      },
      activeNames: ['1', '2']
    }
  },
  methods: {
    init(data){
      this.inputForm = data
    },
    viewInvoiceDetail(){
      this.$router.push({
        path: '/vat_invoice_detail',
        query: {
          data: JSON.stringify(this.inputForm.invoiceDetail.billDetails)
        }
      })
    },
    formatter(value){
      return Number(value).toFixed(2)
    }
  }
}
</script>

<style scoped>

</style>